import { useStaticQuery, graphql } from "gatsby"

// only one query per file, so we put each url in its own file

export const useLoginUrl = () => {
  const data = useStaticQuery(loginUrlQuery)
  return (data.pssHeaderLink || {}).url
}

/**
 * @return The login url with the pageUrl as parameter
 *         so that the user will get there after login.
 */
export const useLoginUrlForPage = (pageUrl) => {
  const loginUrl = useLoginUrl();
  if (!pageUrl) {
    return loginUrl
  }
  return `${loginUrl}?forward_url=${encodeURIComponent(pageUrl)}`
}

const loginUrlQuery = graphql`
    query LoginUrlQuery {
        pssHeaderLink(key: { eq: "loginUrl" }) {
            url
        }
    }
`
